import React from 'react';

const GiftVisualEffects = () => (
  <div className="lumirae-visual-effects" aria-hidden="true">
    <div className="lumirae-ambient-ribbon lumirae-ambient-ribbon-a" />
    <div className="lumirae-ambient-ribbon lumirae-ambient-ribbon-b" />
    <div className="lumirae-light-rail lumirae-light-rail-a" />
    <div className="lumirae-light-rail lumirae-light-rail-b" />
    <div className="lumirae-grain" />
  </div>
);

export default GiftVisualEffects;
